import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToAssetLogReportDateTime } from "../../../utils/dateConvert";
import { downloadCSVFile } from "../../../api/apiClient";

function MessageReport(props) {
    console.log('MessageReport props', props);
    const reports = props.reportDetails?.items;
    let assetName = props.assetCustomerName;
    let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
    let timeZoneID = props.timeZoneID;
    console.log('scv timeZone', timeZone);
    console.log('timeZoneID', timeZoneID);

    const data = (
        <Table striped>
            <thead>
                <tr className="nowwrapTH">
                    <th>Id</th>
                    <th>Device</th>
                    {/*<th>AssetID</th>*/}
                    {/* <th>Device Name</th> */}
                    <th>Received</th>
                    <th>Created</th>
                    {/*<th>SensorAId</th>*/}
                    <th>SensorA</th>
                    {/*<th>SensorBId</th>*/}
                    <th>SensorB</th>
                    <th>DeviceTemp</th>
                    <th>DeviceVolts</th>
                    <th>Satellites</th>
                    <th>TripCount</th>
                    {/* <th>Distance</th> */}
                    <th>Odometer</th>
                    <th>IO0</th>
                    <th>IO1</th>
                    <th>IO2</th>
                    {/* <th>IO 3</th> */}
                    <th>IO8</th>
                    {/* <th>MessageName</th> */}
                    <th>MessageID</th>
                    <th>MessageType</th>
                    <th>MessageName</th>
                    {/* <th>Status</th> */}
                    <th>Location</th>
                    <th>Ibutton</th>
                    <th>GPRS</th>
                    {/*<th>GPRS Created On</th>*/}
                    <th>Heading</th>
                    <th>Latitude</th>
                    <th>Longitude</th>
                    <th>Speed</th>
                    <th>GPS</th>
                    {/*<th>SpeedLimit</th>*/}
                </tr>
            </thead>
            <tbody>
                {reports && reports.map((report, index) => {
                    return (
                        <tr>
                            <td>{report.id}</td>
                            <td>{report.imei}</td>
                            {/*<td>{report.assetID}</td>*/}
                            {/* <td>{report.name}</td> */}
                            <td style={{ whiteSpace: "nowrap" }}>{utcToAssetLogReportDateTime(report.received, timeZoneID)}</td>
                            <td style={{ whiteSpace: "nowrap" }}>{utcToAssetLogReportDateTime(report.created, timeZoneID)}</td>
                            {/*<td>{report.sensorAId}</td>*/}
                            <td>{report.sensorAValue}</td>
                            {/*<td>{report.sensorBId}</td>*/}
                            <td>{report.sensorBValue}</td>
                            <td>{report.deviceTemp}</td>
                            <td>{report.deviceVolts}</td>
                            <td>{report.satellites}</td>
                            <td>{report.tripCount}</td>
                            {/* <td>{report.distance}</td> */}
                            <td>{report.odometer}</td>
                            <td>{report.iO0}</td>
                            <td>{report.iO1}</td>
                            <td>{report.iO2}</td>
                            {/* <td>{report.iO3}</td> */}
                            <td>{report.iO8}</td>
                            {/* <td>{report.messageName}</td> */}
                            <td>{report.messageID}</td>
                            <td>{report.messageType}</td>
                            <td>{report.messageName}</td>
                            {/* <td>{report.status}</td> */}
                            <td>{report.location}</td>
                            <td>{report.ibutton}</td>
                            <td>{report.gprsOnline}</td>
                            {/*<td style={{ whiteSpace: "nowrap" }}>{utcToDDMMYYYY(report.gPRMC_Created)}</td>*/}
                            <td>{report.gPRMC_Heading}</td>
                            <td>{report.gPRMC_Latitude}</td>
                            <td>{report.gPRMC_Longitude}</td>
                            <td>{report.gPRMC_Speed != null ? report.gPRMC_Speed.toFixed(2) : ""}</td>
                            <td>{report.gPRMC_Validity}</td>
                            {/*<td>{report.speedLimit}</td>*/}
                        </tr>
                    );
                })}
            </tbody>
            </Table>
    );
    const handleDownloadExcel = () => {
        if (reports) {
            var rpData = reports.map((report, index) => {
                return {
                    Id : report.id,
                    Device : report.imei.toString(),
                    Received: report.received,
                    Created : report.created,
                    SensorA : report.sensorAValue,
                    SensorB : report.sensorBValue,
                    DeviceTemp : report.deviceTemp,
                    DeviceVolts : report.deviceVolts,
                    Satellites : report.satellites,
                    TripCount : report.tripCount,
                    Odometer : report.odometer,
                    IO0 : report.iO0,
                    IO1 : report.iO1,
                    IO2 : report.iO2,
                    IO8 : report.iO8,
                    MessageID : report.messageID,
                    MessageType : report.messageType,
                    MessageName : report.messageName,
                    Location : report.location,
                    Ibutton : report.ibutton,
                    GPRS : report.gprsOnline,
                    Heading : report.gPRMC_Heading,
                    Latitude : report.gPRMC_Latitude,
                    Longitude : report.gPRMC_Longitud,
                    Speed : report.gPRMC_Speed != null ? report.gPRMC_Speed.toFixed(2) : "",
                    GPS : report.gPRMC_Validity
                };
            });
            console.log(rpData);
            downloadCSVFile(rpData, "AssetLog", assetName, timeZone);
        }
      };
    return (
        <ToggleBar
            caption="Asset Log"
            download={handleDownloadExcel}
            icon="fa-bar-chart"
            color="#337AB7"
            content={data}
            additionalClass="assetLogContainer"
        />
    );
}

export default MessageReport;
